<template>
  <v-row justify="center">
    <v-col cols="11" sm="8" md="6" lg="5" xl="4" class="pt-8">
      <h1 class="text-center">Minimart</h1>
      <v-card class="home pa-5 text-center" outlined>
        <v-alert
          v-if="getShopFetchError"
          type="info"
          border="left"
          dense
          text
          class="proxima--font"
          >Sorry but we couldn't load this shop.</v-alert
        >
        <v-card-text>
          <p class="text-h6"
            >If you are the owner of this shop, please check your settings or
            contact Minimart support at
            <a href="mailto:hi@getminimart.com">hi@getminimart.com</a>.
          </p>
          <p class="text-h6"
            ><v-btn
              @click="$router.go()"
              color="blue darken-2"
              depressed
              large
              block
              class="white--text"
              >Try Loading Again</v-btn
            >
          </p>
          <p class="small">Error code : {{ getShopFetchError }}</p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { GuestRoutes } from '@/constants/RouteNames'
import { mapGetters } from 'vuex'
export default {
  name: 'ShopErrorView',
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters('shop', ['getShopFetchError']),
  },
  watch: {
    getIsMaintenanceModeOn: {
      handler(val) {
        if (!val) {
          this.$router.push({ name: GuestRoutes.HOME })
        }
      },
      immediate: true,
    },
  },
}
</script>
